import axiosInstance from "../../../api/axiosInstance";

//function for deleted one measure.
let deleteObject = async(user, method, id) => {
    return new Promise((resolve, reject) => {   
        let uri = process.env.REACT_APP_API  + "/" + method + id;
        if (user != null && user != undefined && user != "") {
            uri = process.env.REACT_APP_API  + "/" + method + "/" + id + "/" + user?.profile + "/" + user?.locale;
        }
    
        axiosInstance.delete(uri).then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export default deleteObject